import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";

export default function P301Chart2({ data }) {

    const [show, setShow] = useState(false);
    const dataConf = {
        options: {
            chart: {
                id: "basic-bar",
                type: "line",
                toolbar: {
                    show: true,
                    tools: {
                        download: false,
                        selection: true,
                        zoom: true,
                        zoomin: false,
                        zoomout: false,
                        pan: true,
                    },
                },
            },
            // colors: ['#de7914','#1bde14'],
            grid: {
                // show: true,
                borderColor: "#e7e7e7",
                row: {
                    colors: ["#f3f3f3", "transparent"],
                    opacity: 0.5,
                },
                padding: {
                    top: 10,
                    right: 10,
                    bottom: 0,
                    left: 10
                }, 
            },
            xaxis: {
                //   categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998 ,1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008],
                categories: data.seriesList,
                labels: {
                    // show: true,
                    rotate: -90,
                    // offsetX: 0,
                    // offsetY: -5,
                    // maxWidth: 200,
                    maxHeight: 200,
                },
            },
            plotOptions: {
                bar: {
                    borderRadius: 4,
                    // horizontal: true,
                    columnWidth: '50%',
                    // barHeight: '50%',
                },
            },
            dataLabels: {
                enabled: false,
            },
            markers: {
                size: 1,
            },
            legend: {
                show: true,
                position: "top",
                horizontalAlign: "left",
                floating: true,
                offsetX: 0,
                offsetY: -5,
            },
        },
        series: [
            {
                name: "ประมาณการ",
                data: data.valList1,
                // data: [28, 29, 33, 36, 32, 32, 33],
            },
            {
                name: "เบิกจริง",
                data: data.valList2,
                // data: [12, 11, 14, 18, 17, 13, 13],
            },
        ],
    };

    useEffect(() => {
        if (data) {
            setShow(true);
        }
    }, [data]);

    return (
        <div>
            <div className="card" style={{ height: "auto" }}>
                <h2 className="centerText" style={{ textAlign: "center" }}>
                    ประมาณการเบิกจ่ายและเบิกจ่ายจริง(ล้านบาท)
                </h2>

                {show === true ? <Chart options={dataConf.options} series={dataConf.series} type="line" height="300" /> : ""}
            </div>
        </div>
    );
}
